import { createResourceCollection } from '@/request'
import { ResourceModel } from '@/request/types'

/**
 * One row returned by the Postgres function kill_long_running_queries(): a query that had been
 * active longer than the threshold when the call ran.
 */
export type LongRunningQueryRow = {
  pid: number
  hours: number | null
  usename: string | null
  application_name: string | null
  query: string | null
  /** 'dry_run' when only listed, 'cancelled' when pg_cancel_backend was sent, 'error: …' otherwise */
  action: string
  /** null on dry run, true/false on a real run */
  succeeded: boolean | null
}

/**
 * Result of the admin long-running-queries tool.
 *
 * API endpoint: POST /api/admin/long_running_queries/ (an action/RPC, not a REST resource — driven
 * via the collection's `useCreate`). Only the latest result is kept, so it uses a constant
 * computedId. `dry_run` / `threshold_minutes` are also the request body fields (see the
 * createCreationHook caveat: the resource type must include what is POSTed).
 */
export type AdminLongRunningQueriesResource = {
  dry_run?: boolean
  threshold_minutes: number
  action?: 'dry_run' | 'cancel'
  requested_by?: string
  rows?: LongRunningQueryRow[]
} & ResourceModel

export const adminLongRunningQueriesCollection =
  createResourceCollection<AdminLongRunningQueriesResource>({
    name: 'adminLongRunningQueries',
    computedId: () => 'result',
    selector: (state) => state.adminLongRunningQueries,
  })

export const adminLongRunningQueriesReducer =
  adminLongRunningQueriesCollection.slice.reducer
